import React from "react";
import HeaderComponent from "../../components/header/header.component";
import { ContentLayout } from "../../layouts/content/content.layout";
import SupportBlockComponent from "../../components/support/support.component";
import CourseDetailsContentComponent from "../../modules/educations/components/course-details/course-details-content/course-details-content.component";

const CourseDetailsPage = (props: any) => {
  const courseId = props.match.params.id;

  return (
    <>
      <HeaderComponent />
      <ContentLayout>
        <CourseDetailsContentComponent courseId={courseId} />
        <SupportBlockComponent />
      </ContentLayout>
    </>
  );
};
export default CourseDetailsPage;
